type DraftWriter<T> = (value: T) => Promise<void>

export class DraftQueueInvalidatedError extends Error {
  constructor() {
    super('Draft queue was invalidated')
    this.name = 'DraftQueueInvalidatedError'
  }
}

/**
 * Serializes draft writes. The session version each write sends is owned by `ProviderAPIClient`,
 * which advances it from every response, so the queue never holds a copy that could go stale.
 */
export class ClinicalSummaryDraftQueue<T> {
  private tail: Promise<void> = Promise.resolve()
  private generation = 0

  constructor(private readonly writer: DraftWriter<T>) {}

  enqueue(value: T): Promise<void> {
    const generation = this.generation
    const run = this.tail.then(async () => {
      if (generation !== this.generation) throw new DraftQueueInvalidatedError()
      await this.writer(value)
    })
    this.tail = run.then(
      () => undefined,
      () => undefined
    )
    return run
  }

  whenIdle(): Promise<void> {
    return this.tail
  }

  /** Writes queued before this call are dropped; the one in flight still finishes. */
  invalidate(): void {
    this.generation += 1
  }
}
